module.exports = __webpack_public_path__ + "static/img/解决方案banner.ecdba82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/解决方案banner.png
// module id = ky25
// module chunks = 0